import React from "react";

export default function Error({ children }) {
  return (
    <div className="invalid-feedback px-1 animated fadeIn d-block ">
      {children}
    </div>
  );
}
